export interface UpsertMerchantUserSettings {
    holdWithdrawal: string;
    staticCommissionRateSettings: UpsertMerchantUserStaticCommissionRate;
    ladderCommissionRateSettings: UpsertMerchantUserLadderCommissionRate;
}

export interface UpsertMerchantUserStaticCommissionRate {
    active: boolean;
    staticMerchantPayinCommissionRate: string;
    staticMerchantPayoutCommissionRate: string;
}

export interface UpsertMerchantUserLadderCommissionRate {
    active: boolean;
    firstLevelMerchantPayinCommissionRate: string;
    firstLevelMerchantPayoutCommissionRate: string;
    firstLevelMonthlyVolume: string;
    secondLevelMerchantPayinCommissionRate: string;
    secondLevelMerchantPayoutCommissionRate: string;
    secondLevelMonthlyVolume: string;
    thirdLevelMerchantPayinCommissionRate: string;
    thirdLevelMerchantPayoutCommissionRate: string;
    thirdLevelMonthlyVolume: string;
}
